import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import { DateFormatter, formatDate } from '../Common/dateFormat';
import ConfirmActionModal from '../Common/confirmActionModal';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { ROOT_URL } from '../../actions/root_url';
import { toFromDates } from '../Common/cleanDates';
import checkPermission from '../Common/permissions';

momentLocalizer(moment);

const getBsStyle = (input, value) => {
  return input === value ? 'success' : 'primary';
};

const renderRadios = props => {
    const renderStartDatePicker = (days) => {
      if (days === '-1') {
        return (
          <Button bsStyle='primary'>
            <Field name='FromDate' placeholder={'Start'} component={DatePicker} />
          </Button>
        );
      }
      return (
        <Button bsStyle='primary'>
          <Field name='FromDate' placeholder={'Start'} component={DisabledDatePicker} />
        </Button>
      );
    };
    const renderEndDatePicker = (days) => {
      if (days === '-1') {
        return (
          <Button bsStyle='primary'>
            <Field name='ToDate' placeholder={'End'} component={DatePicker} />
          </Button>
        );
      }
      return (
        <Button bsStyle='primary'>
          <Field name='ToDate' placeholder={'End'} component={DisabledDatePicker} />
        </Button>
      );
    };
    return (
      <ButtonToolbar className='radio-filter-buttons'>
        <Button bsStyle={getBsStyle(props.input.value, '1')}>
          <div className='radio'>
            <label htmlFor='today-radio-filter'>
              <input {...props.input} id='today-radio-filter' type='radio' name='dateFilterRadios' value='1' onClick={() => props.fetchAR(1)} checked={props.input.value === '1'} />
              <Translate value="today" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '7')}>
          <div className='radio'>
            <label htmlFor='sevenDay-radio-filter'>
              <input {...props.input} id='sevenDay-radio-filter' type='radio' name='dateFilterRadios' value='7' onClick={() => props.fetchAR(7)} checked={props.input.value === '7'} />
              7 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '30')}>
          <div className='radio'>
            <label htmlFor='thirtyDay-radio-filter'>
              <input {...props.input} id='thirtyDay-radio-filter' type='radio' name='dateFilterRadios' value='30' onClick={() => props.fetchAR(30)} checked={props.input.value === '30'} />
              30 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '90')}>
          <div className='radio'>
            <label htmlFor='ninetyDay-radio-filter'>
              <input {...props.input} id='ninetyDay-radio-filter' type='radio' name='dateFilterRadios' value='90' onClick={() => props.fetchAR(90)} checked={props.input.value === '90'} />
              90 <Translate value="days" />
            </label>
          </div>
        </Button>
        <Button bsStyle={getBsStyle(props.input.value, '-1')}>
          <div className='radio'>
            <label htmlFor='dateRange-radio-filter'>
              <input {...props.input} id='dateRange-radio-filter' type='radio' name='dateFilterRadios' value='-1' checked={props.input.value === '-1'} />
              <Translate value="date_range" />
            </label>
          </div>
        </Button>
        {renderStartDatePicker(props.days)}
        {renderEndDatePicker(props.days)}
        {/* <Button
          bsStyle='primary'
          className='search-btn'
          type='submit'
          onClick={() => props.fetchAR(-1)}
        >
          <em className='fa fa-search' />
        </Button> */}
      </ButtonToolbar>
    );
};

class ARList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            ar: {
              rows: [],
              selectedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            arDetail: {
              rows: [],
              selectedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null
            },
            arOpen: false,
            customer: null,
            payment_id: null,
            title: '',
            checkAuthorizeOpen: false,
            total: 0,
            fromDate: '1900-01-01',
            toDate: '3000-01-01',
            rowsCount: 0,
        };
        this.fetchAR = this.fetchAR.bind(this);
        this.editAR = this.editAR.bind(this);
        this.createAR = this.createAR.bind(this);
        this.checkAuthorize = this.checkAuthorize.bind(this);
        this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
        this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    }

    componentWillMount() {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const days = '7';
      this.props.fetchAR(fromDate, toDate, days);
      this.props.setDefaultOfForm('Days', '7', 'arList');
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.ar && nextProps.ar !== this.props.ar) {
        const ar = { ...this.state.ar, rows: nextProps.ar.Payments };
        this.setState({ ar, total: nextProps.ar.Total });
      }
      if (nextProps.arDetail && nextProps.arDetail !== this.props.arDetail) {
        const arDetail = { ...this.state.arDetail, rows: nextProps.arDetail.Invoices };
        this.setState({ arDetail });
      }
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        this.voidAR();
      }
      if (nextProps.days !== this.props.days) {
        this.props.setDefaultOfForm('FromDate', null, 'arList');
        this.props.setDefaultOfForm('ToDate', null, 'arList');
      }
      if (!nextProps.days) {
        this.props.setDefaultOfForm('Days', '7', 'arList');
      }
      if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
        this.setState({ fromDate: nextProps.fromDate }, this.fetchAR);
      }
      if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
        this.setState({ toDate: nextProps.toDate }, this.fetchAR);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.ar !== this.state.ar) {
        this.setState({ rowsCount: Data.Selectors.getRows(this.state.ar).length });
      }
    }

    voidAR() {
      let newRows = this.state.ar.rows;
      this.state.ar.selectedRows.map(row => {
        this.props.deleteAR(row.Payment_id);
        newRows = newRows.filter((obj) => obj !== row);
        const ar = { ...this.state.ar, rows: newRows };
        this.setState({ ar });
      });
    }

    fetchAR(days) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (this.state.fromDate != null) {
        fromDate = moment(this.state.fromDate).format('YYYY-MM-DD');
      }
      if (this.state.toDate != null) {
        toDate = moment(this.state.toDate).format('YYYY-MM-DD');
      }
      this.props.fetchAR(fromDate, toDate, days);
    }

    editAR() {
      this.context.router.push(`/AR/${this.state.ar.selectedRows[0].Payment_id}`);
    }

    createAR() {
      this.props.clearARDetail();
      this.context.router.push('/AR/new');
    }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeCheckAuthorize() {
      this.setState({ checkAuthorizeOpen: false });
    }

    shouldVoidButtonDisable() {
      const { selectedRows } = this.state.ar;

      // Always disable void if selected more than 1 row
      if (selectedRows.length !== 1) {
        return true;
      }

      const status = selectedRows[0] ? selectedRows[0].Status : 'disable';
      const disabled = (
        status === 'Bounced Check' ||
        status === 'Void' ||
        status === 'disable'
      );
      return disabled;
    }

    renderTable() {
        if (this.props.isLoading && !this.props.error) {
          return <Spinner />;
        } else if (this.props.error) {
          return (
            <ContentWrapper>
              <div className='alert alert-danger'>
                {JSON.stringify(this.props.error)}
              </div>
            </ContentWrapper>
          );
        }
        // Parameters of the react-data-grid
        const getRows = () => {
            return Data.Selectors.getRows(this.state.ar);
        };

        const getSize = () => {
            return getRows().length;
        };

        const rowGetter = rowIdx => {
            const rows = getRows();
            return rows[rowIdx];
        };

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            const ar = Object.assign({}, this.state.ar, { sortColumn, sortDirection });
            this.setState({ ar });
        };

        const handleFilterChange = filter => {
            const newFilters = Object.assign({}, this.state.ar.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const ar = { ...this.state.ar, filters: newFilters };
            this.setState({ ar });
        };

        const onClearFilters = () => {
             //all filters removed
             const ar = { ...this.state.ar, filters: {} };
             this.setState({ ar });
        };

        // Handle the row select function

        const onRowsSelected = (rows) => {
             const newRows = getRows();
             const selectedRows = [];
             newRows.map(r => {
               r.isSelected = false;
             });
             rows.map(r => {
               newRows[r.rowIdx].isSelected = true;
               selectedRows.push(r.row);
             });
             const ar = { ...this.state.ar, rows: newRows, selectedRows };
             this.setState({ ar });
        };

         const onRowsDeselected = (rows) => {
             const newRows = getRows();
             rows.map(r => {
               newRows[r.rowIdx].isSelected = false;
             });
             const selectedRows = [];
             const ar = { ...this.state.ar, rows: newRows, selectedRows };
             this.setState({ ar });
         };

         const onRowClick = (rowIdx, row) => {
           if (rowIdx > -1) {
             this.props.fetchARDetail(row.Payment_id);
           }
         };

        // Column difinition

        const columns = [
          {
              key: 'ARNum',
              name: <Translate value="ar_num" />,
              width: 110,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'PaymentDate',
              name: <Translate value="pmt_date" />,
              width: 90,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'PostingDate',
              name: <Translate value="create_time" />,
              width: 90,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'CustomerName',
              name: <Translate value="customer_name" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Method',
              name: <Translate value="method" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'CheckNum',
              name: <Translate value="check" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'TotalPayment',
              name: <Translate value="amount" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'AccountName',
              name: <Translate value="account" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Status',
              name: <Translate value="status" />,
              width: 70,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
            key: 'PaymentType',
            name: <Translate value="payment" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
          {
              key: 'Note',
              name: <Translate value="note" />,
              resizable: true,
              sortable: true,
              filterable: true
          },
        ];

        return (
          <Row>
            <Col sm={12}>
              <div style={{ maxWidth: '100%' }} id="ARList-dataGrid1">
                <ReactDataGrid
                  onGridSort={handleGridSort}
                  toolbar={<Toolbar enableFilter={true} />}
                  onAddFilter={handleFilterChange}
                  onClearFilters={onClearFilters}
                  columns={columns}
                  rowHeight={25}
                  minHeight={320}
                  headerRowHeight={45}
                  enableRowSelect='single'
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  onRowClick={onRowClick}
                  rowSelection={{
                    showCheckbox: true,
                    enableShiftSelect: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                     isSelectedKey: 'isSelected'
                    }
                  }}
                />
              </div>
            </Col>
          </Row>
        );
    }

    renderDetailTable() {
        if (this.props.arDetailIsLoading && !this.props.arDetailError) {
          return <Spinner />;
        } else if (this.props.arDetailError) {
          return (
            <ContentWrapper>
              <div className='alert alert-danger'>
                {JSON.stringify(this.props.arDetailError)}
              </div>
            </ContentWrapper>
          );
        }
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.arDetail);
        };

        const getSize = () => {
            return getRows().length;
        };

        const rowGetter = rowIdx => {
            const rows = getRows();
            return rows[rowIdx];
        };

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            const arDetail = Object.assign({}, this.state.arDetail, { sortColumn, sortDirection });
            this.setState({ arDetail });
        };

        // Column difinition

        const columns = [
          {
              key: 'InvoiceNum',
              name: <Translate value="invoice_no" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'PostingDate',
              name: <Translate value="invoice_date" />,
              width: 120,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: DateFormatter
          },
          {
              key: 'Name',
              name: <Translate value="customer_name" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="description" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
          {
              key: 'UnpaidAmount',
              name: <Translate value="balance" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'Amount',
              name: <Translate value="payment" />,
              width: 80,
              resizable: true,
              sortable: true,
              filterable: true,
              formatter: CashFormatter,
          },
          {
              key: 'Note',
              name: <Translate value="note" />,
              width: 150,
              resizable: true,
              sortable: true,
              filterable: true
          },
        ];

        return (
          <Row>
            <Col sm={12}>
              <div style={{ maxWidth: '100%' }} id="ARList-dataGrid2">
                <ReactDataGrid
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  minHeight={220}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                />
              </div>
            </Col>
          </Row>
        );
    }

    renderPrint() {
      const url = `${ROOT_URL}v1/sale/printorder/?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle='primary'
          type='button'
          href={url}
          disabled
        >
          <em className='fa fa-print' /><Translate value="print" />
        </Button>
      );
    }

    renderExportButton() {
      let { days } = this.props;
      const { fromDate: f, toDate: t } = this.props;
      days = days || 7;
      const { fromDate, toDate } = toFromDates(days, f, t);
      const params = `PaymentDate__gte=${fromDate}&PaymentDate__lte=${toDate}`;
      const token = localStorage.getItem('token');
      const url = `${ROOT_URL}/v1/ar/payment/export/?${params}&Bearer=${token}`;
      return (
        <Button
          bsStyle='success'
          type='button'
          href={url}
          disabled={!checkPermission('print_account_receivable')}
        >
          <em className='fa fa-print' />
          <Translate value="excel" />
        </Button>
      );
    }

    render() {
      const createDialogStyle = {
          width: '550px',
          height: '300px',
          marginLeft: '-15%',
      };
      return (
          <ContentWrapper>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="ar_slashsign_ap" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                <Translate value="account_receivable_receive_report" />
              </Breadcrumb.Item>
            </Breadcrumb> {/* End Navigation Trail */}

            <ButtonToolbar>
              { this.renderExportButton() }
            </ButtonToolbar>

            <Grid id='AR'>
              <Panel id='date-range-picker' className='form-horizontal'>
                <Row>
                  <Col xs={1}>
                    <h3><Translate value="payment_date" /><span className='colon'>:</span></h3>
                  </Col>
                  <Col xs={11}>
                    <Field name='Days' component={renderRadios} fetchAR={this.fetchAR} days={this.props.days} />
                  </Col>
                </Row>
              </Panel>
              <Panel id='ar-table' className='position-relative table-collapse-fix'>
                <ButtonToolbar className='table-buttons'>
                  <Button
                    bsStyle='success'
                    onClick={this.createAR}
                    disabled={!checkPermission('add_account_receivable')}
                  >
                    <em className='fa fa-plus' /><Translate value="create" />
                  </Button>
                  <Button
                    bsStyle='warning'
                    onClick={this.editAR}
                    disabled={!this.state.ar.selectedRows || this.state.ar.selectedRows.length !== 1 || !checkPermission('change_account_receivable')}
                  >
                    <em className='fa fa-pencil' /><Translate value="edit" />
                  </Button>
                  <Button
                    bsStyle='danger'
                    type='button'
                    onClick={() => { this.openCheckAuthorize('remove'); }}
                    disabled={this.shouldVoidButtonDisable() || !checkPermission('delete_account_receivable')}
                  >
                    <em className="fa fa-trash" /><Translate value="void" />
                  </Button>
                </ButtonToolbar>
                { this.renderTable() }
                <Row className="grand-total">
                  <Col xs={5}>
                    <label>
                      <Translate value="rows" />:&nbsp;
                      <span className="font-color-orange">{ this.state.rowsCount }</span>
                    </label>
                  </Col>
                  <Col xs={6}>
                    <Col style={{ 'margin-top': '2px' }} xs={2} xsOffset={1}>
                      <span>
                        <label style={{'display': 'inline-flex'}}><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:</label>
                      </span>
                    </Col>
                    <Col xs={2}>
                      <Field component={DisabledInputField} placeholder={this.state.total || 0}/>
                    </Col>
                  </Col>
                </Row>
              </Panel>
              <h2><Translate value="payment_detail" /></h2>
              <Panel id='ar-table-detail' className='details-table-collapse-fix'>
                { this.renderDetailTable() }
              </Panel>
            </Grid>
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.checkAuthorizeOpen}
              onCloseClicked={this.closeCheckAuthorize}
            >
              <ConfirmActionModal
                case='confirmPassword'
                closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
              />
            </SkyLightStateless>
          </ContentWrapper>
      );
    }

}

export default ARList;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/ARList.jsx